import { Injectable, inject } from '@angular/core';
import { type ReportingComparisonPdfHttpBody } from 'ag-common-lib/lib/contracts/reporting-api.contracts';
import { ReportingApiService, type ReportingApiBlobResponse } from '../../../services/reporting-api.service';

/**
 * The Comparison page as a PDF, built by the reporting API.
 *
 * What goes over is the page's arrangement and the blocks to print, never a figure: the API
 * reruns the queries itself, so what comes back carries the numbers the server stands behind.
 */
@Injectable()
export class ProductionComparisonPdfService {
  private static readonly pdfPath = '/api/reports/comparison/pdf';

  private readonly reportingApiService = inject(ReportingApiService);

  render(body: ReportingComparisonPdfHttpBody): Promise<ReportingApiBlobResponse> {
    return this.reportingApiService.requestBlob(ProductionComparisonPdfService.pdfPath, { method: 'POST', body });
  }
}
